/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const GetDatabaseUserResponse = core.serialization.object({
    username: core.serialization.string(),
    password: core.serialization.string(),
});
